"use strict";

var _interopRequireWildcard = require("@babel/runtime-corejs2/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime-corejs2/helpers/interopRequireDefault");

var _Object$defineProperty = require("@babel/runtime-corejs2/core-js/object/define-property");

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports["default"] = exports.DATA_OBJECT_TYPE_GAME_GROUP = exports.DATA_OBJECT_TYPE_GAME = exports.PLUGIN_EQUIZZER = exports.FEATURE_NAME = void 0;

var _regenerator = _interopRequireDefault(require("@babel/runtime-corejs2/regenerator"));

var _promise = _interopRequireDefault(require("@babel/runtime-corejs2/core-js/promise"));

var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/asyncToGenerator"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/createClass"));

var _sha = _interopRequireDefault(require("sha1"));

var _BuildConstants = require("../../../../utils/BuildConstants");

var _HttpRequest = require("../../../../utils/HttpRequest");

var _RegisterInstance = _interopRequireDefault(require("../../../../KESI2/Services/RegisterInstance"));

var _EquizzerActions = _interopRequireDefault(require("../../Equizzer/actions/EquizzerActions"));

var _config = _interopRequireDefault(require("../../../../../targets/cord_eurofh_teams/config.js"));

var _EquizzerRegisterHelper = require("../EquizzerRegisterHelper");

var _DataStore = _interopRequireWildcard(require("../../../../KESI2/Stores/DataStore2"));

var FEATURE_NAME = 'equeoqd';
exports.FEATURE_NAME = FEATURE_NAME;
var PLUGIN_EQUIZZER = 'EquizzerPlugin';
exports.PLUGIN_EQUIZZER = PLUGIN_EQUIZZER;
var DATA_OBJECT_TYPE_GAME = 'EquizzerGame';
exports.DATA_OBJECT_TYPE_GAME = DATA_OBJECT_TYPE_GAME;
var DATA_OBJECT_TYPE_GAME_GROUP = 'EquizzerUserGroup';
exports.DATA_OBJECT_TYPE_GAME_GROUP = DATA_OBJECT_TYPE_GAME_GROUP;
var CHECK_ACTIVATION_URL = 'mobile/api/features/v2/checkRequestCode';
var REVALIDATE_USER_URL = 'mobile/api/features/v2/revalidateUser';
var CREATE_USER_URL = 'mobile/api/features/v2/createUser';
var REQUEST_USERNAME_SEND = 'mobile/api/features/v2/requestUsernameSend';
var REQUEST_PASSWORD_RESET_URL = 'mobile/api/features/v2/requestPasswordReset';
var CHANGE_PASSWORD_URL = 'mobile/api/features/v2/changePassword';
var CHECK_LIST_STATES_URL = 'mobile/api/features/v2/listStates';
var GET_USER_URL = 'mobile/api/features/v2/getUser';
var CHECK_ACTIVATION_URL_AUTH = 'rest/api/v1/backAuth/checkRequestCode';
var CHECK_SNOMID_URL_AUTH = 'rest/api/v1/backAuth/checkSnomId';
var REVALIDATE_USER_URL_AUTH = 'rest/api/v1/backAuth/revalidateUser';
var CREATE_USER_URL_AUTH = 'rest/api/v1/backAuth/createUser';
var GET_USER_URL_AUTH = 'rest/api/v1/backAuth/getUser';
var REQUEST_USERNAME_SEND_AUTH = 'rest/api/v1/backAuth/requestUsernameSend';
var REQUEST_PASSWORD_RESET_URL_AUTH = 'rest/api/v1/backAuth/requestPasswordReset';
var CHECK_PASSWORD_RESET_TOKEN_URL_AUTH = 'auth/allowPasswordReset';
var REQUEST_REGISTRATION_TOKEN_URL_AUTH = 'rest/api/v1/backAuth/requestRegistrationToken';
var CHECK_REGISTRATION_TOKEN_URL_AUTH = 'rest/api/v1/backAuth/checkRegistrationToken';
var CHANGE_PASSWORD_URL_AUTH = 'rest/api/v1/backAuth/changePassword';
var CHECK_LIST_STATES_URL_AUTH = 'rest/api/v1/backAuth/listStates';
var CREATE_ACTIVATON_CODE_URL_AUTH = 'rest/api/v1/activationCode/create';
var GET_STRUCTURE_DATA_URL_AUTH = 'rest/api/v1/structure/index';
var SEND_PUSH_URL_AUTH = 'rest/api/v1/sendPush';
var SEND_PUSH_FILTERED_URL_AUTH = 'rest/api/v1/sendPush/sendFiltered';
var GET_ACTIVITY_URL_AUTH = 'rest/api/v1/structure/events';
var GET_USER_PICTURES_URL_AUTH = 'rest/api/v1/structure/pictures';
var GET_GLOBAL_RANKING_URL_AUTH = 'rest/api/v1/structure/ranking';
var CANDIDATE_URL_AUTH = 'rest/v1/candidate';
var RECRUITER_CONFIG_URL_AUTH = 'rest/api/v1/activationCode/updateRecruiterConfig';
var USER_MANAGEMENT_HTTP_TIMEOUT = 20000;
var SEND_PUSH_TIMEOUT = 90000;
var STRUCTURE_TIMEOUT = 45000;

var UserManagementService = /*#__PURE__*/function () {
  function UserManagementService() {
    (0, _classCallCheck2["default"])(this, UserManagementService);
  }

  (0, _createClass2["default"])(UserManagementService, null, [{
    key: "getUser",
    value: function () {
      var _getUser = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee(username) {
        var params, response;
        return _regenerator["default"].wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.prev = 0;
                console.log('get user!');
                _context.next = 4;
                return _RegisterInstance["default"].getApplicationInstanceId();

              case 4:
                _context.t0 = _context.sent;
                _context.t1 = username;
                params = {
                  deviceuuid: _context.t0,
                  username: _context.t1
                };
                _context.next = 9;
                return (0, _HttpRequest.httpGet)("".concat(_BuildConstants.HOST, "/").concat(GET_USER_URL), params, null, USER_MANAGEMENT_HTTP_TIMEOUT, 10);

              case 9:
                response = _context.sent;

                if (!(response.data.success !== true)) {
                  _context.next = 12;
                  break;
                }

                return _context.abrupt("return", _promise["default"].reject(response.data.errors[0]));

              case 12:
                return _context.abrupt("return", _promise["default"].resolve(response.data));

              case 15:
                _context.prev = 15;
                _context.t2 = _context["catch"](0);
                console.log('ERROR: could not get user', _context.t2);
                return _context.abrupt("return", _promise["default"].reject(_context.t2));

              case 19:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, null, [[0, 15]]);
      }));

      function getUser(_x) {
        return _getUser.apply(this, arguments);
      }

      return getUser;
    }()
  }, {
    key: "getUserFromAuthServer",
    value: function () {
      var _getUserFromAuthServer = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee2() {
        var params, accessToken, response;
        return _regenerator["default"].wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _context2.prev = 0;
                console.log('get user from auth server!');
                _context2.next = 4;
                return _RegisterInstance["default"].getApplicationInstanceId();

              case 4:
                _context2.t0 = _context2.sent;
                params = {
                  deviceuuid: _context2.t0,
                  withData: true
                };
                _context2.next = 8;
                return _RegisterInstance["default"].getAccessToken('authUser:read');

              case 8:
                accessToken = _context2.sent;
                _context2.next = 11;
                return (0, _HttpRequest.httpPost)("".concat(_BuildConstants.AUTH_HOST, "/").concat(GET_USER_URL_AUTH), params, null, false, USER_MANAGEMENT_HTTP_TIMEOUT, 2, "Bearer ".concat(accessToken));

              case 11:
                response = _context2.sent;

                if (!(response.data.success !== true)) {
                  _context2.next = 14;
                  break;
                }

                return _context2.abrupt("return", _promise["default"].reject(response.data.errors[0]));

              case 14:
                return _context2.abrupt("return", _promise["default"].resolve(response.data));

              case 17:
                _context2.prev = 17;
                _context2.t1 = _context2["catch"](0);
                console.log('ERROR: could not get user', _context2.t1);
                return _context2.abrupt("return", _promise["default"].reject(_context2.t1));

              case 21:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, null, [[0, 17]]);
      }));

      function getUserFromAuthServer() {
        return _getUserFromAuthServer.apply(this, arguments);
      }

      return getUserFromAuthServer;
    }()
  }, {
    key: "getStructureData",
    value: function () {
      var _getStructureData = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee3() {
        var data, token, response;
        return _regenerator["default"].wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                _context3.prev = 0;
                console.log('getStructureData!');
                _context3.next = 4;
                return _RegisterInstance["default"].getApplicationInstanceId();

              case 4:
                _context3.t0 = _context3.sent;
                data = {
                  deviceuuid: _context3.t0
                };
                _context3.next = 8;
                return _RegisterInstance["default"].getAccessToken('structure:read');

              case 8:
                token = _context3.sent;
                _context3.next = 11;
                return (0, _HttpRequest.httpGet)("".concat(_BuildConstants.AUTH_HOST, "/").concat(GET_STRUCTURE_DATA_URL_AUTH), data, null, STRUCTURE_TIMEOUT, 10, 'Bearer ' + token);

              case 11:
                response = _context3.sent;

                if (!(response.data.success !== true)) {
                  _context3.next = 14;
                  break;
                }

                return _context3.abrupt("return", _promise["default"].reject(response.data.errors[0]));

              case 14:
                return _context3.abrupt("return", _promise["default"].resolve(response.data));

              case 17:
                _context3.prev = 17;
                _context3.t1 = _context3["catch"](0);
                console.log('ERROR: could not get structure data', _context3.t1);
                return _context3.abrupt("return", _promise["default"].reject(_context3.t1));

              case 21:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3, null, [[0, 17]]);
      }));

      function getStructureData() {
        return _getStructureData.apply(this, arguments);
      }

      return getStructureData;
    }()
  }, {
    key: "getCandidateList",
    value: function () {
      var _getCandidateList = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee4() {
        var token, response;
        return _regenerator["default"].wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                _context4.prev = 0;
                console.log('getCandidateList!');
                _context4.next = 4;
                return _RegisterInstance["default"].getAccessToken('candidate:read');

              case 4:
                token = _context4.sent;
                _context4.next = 7;
                return (0, _HttpRequest.httpGet)("".concat(_BuildConstants.RECRUIT_HOST, "/").concat(CANDIDATE_URL_AUTH), {}, null, STRUCTURE_TIMEOUT, 10, 'Bearer ' + token);

              case 7:
                response = _context4.sent;
                console.log('response', response);

                if (!(response.status !== 200)) {
                  _context4.next = 11;
                  break;
                }

                return _context4.abrupt("return", _promise["default"].reject(response.data.errors[0]));

              case 11:
                return _context4.abrupt("return", _promise["default"].resolve(response.data));

              case 14:
                _context4.prev = 14;
                _context4.t0 = _context4["catch"](0);
                console.log('ERROR: could not get candidate list', _context4.t0);
                return _context4.abrupt("return", _promise["default"].reject(_context4.t0));

              case 18:
              case "end":
                return _context4.stop();
            }
          }
        }, _callee4, null, [[0, 14]]);
      }));

      function getCandidateList() {
        return _getCandidateList.apply(this, arguments);
      }

      return getCandidateList;
    }()
  }, {
    key: "postCandidate",
    value: function () {
      var _postCandidate = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee5(candidateData) {
        var token, response;
        return _regenerator["default"].wrap(function _callee5$(_context5) {
          while (1) {
            switch (_context5.prev = _context5.next) {
              case 0:
                _context5.prev = 0;
                console.log('postCandidate!');
                _context5.next = 4;
                return _RegisterInstance["default"].getAccessToken('candidate:write');

              case 4:
                token = _context5.sent;
                _context5.next = 7;
                return (0, _HttpRequest.httpPostJsonEncoded)("".concat(_BuildConstants.RECRUIT_HOST, "/").concat(CANDIDATE_URL_AUTH), candidateData, null, STRUCTURE_TIMEOUT, 10, 'Bearer ' + token);

              case 7:
                response = _context5.sent;
                console.log('response', response);

                if (!(response.status !== 200 && response.status !== 201)) {
                  _context5.next = 11;
                  break;
                }

                return _context5.abrupt("return", _promise["default"].reject(response.data.errors[0]));

              case 11:
                return _context5.abrupt("return", _promise["default"].resolve(response.data));

              case 14:
                _context5.prev = 14;
                _context5.t0 = _context5["catch"](0);
                console.log('ERROR: could not post candidate', _context5.t0);
                return _context5.abrupt("return", _promise["default"].reject(_context5.t0));

              case 18:
              case "end":
                return _context5.stop();
            }
          }
        }, _callee5, null, [[0, 14]]);
      }));

      function postCandidate(_x2) {
        return _postCandidate.apply(this, arguments);
      }

      return postCandidate;
    }()
  }, {
    key: "removeCandidate",
    value: function () {
      var _removeCandidate = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee6(candidateData) {
        var token, response;
        return _regenerator["default"].wrap(function _callee6$(_context6) {
          while (1) {
            switch (_context6.prev = _context6.next) {
              case 0:
                _context6.prev = 0;
                console.log('removeCandidate!');
                _context6.next = 4;
                return _RegisterInstance["default"].getAccessToken('candidate:write');

              case 4:
                token = _context6.sent;
                _context6.next = 7;
                return (0, _HttpRequest.httpDeleteJsonEncoded)("".concat(_BuildConstants.RECRUIT_HOST, "/").concat(CANDIDATE_URL_AUTH, "/").concat(candidateData.id), candidateData, null, STRUCTURE_TIMEOUT, 10, 'Bearer ' + token);

              case 7:
                response = _context6.sent;
                console.log('response', response);

                if (!(response.status !== 200 && response.status !== 201)) {
                  _context6.next = 11;
                  break;
                }

                return _context6.abrupt("return", _promise["default"].reject(response.data.errors[0]));

              case 11:
                return _context6.abrupt("return", _promise["default"].resolve(response.data));

              case 14:
                _context6.prev = 14;
                _context6.t0 = _context6["catch"](0);
                console.log('ERROR: could not post candidate', _context6.t0);
                return _context6.abrupt("return", _promise["default"].reject(_context6.t0));

              case 18:
              case "end":
                return _context6.stop();
            }
          }
        }, _callee6, null, [[0, 14]]);
      }));

      function removeCandidate(_x3) {
        return _removeCandidate.apply(this, arguments);
      }

      return removeCandidate;
    }()
  }, {
    key: "updateCandidate",
    value: function () {
      var _updateCandidate = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee7(candidateData) {
        var token, response;
        return _regenerator["default"].wrap(function _callee7$(_context7) {
          while (1) {
            switch (_context7.prev = _context7.next) {
              case 0:
                _context7.prev = 0;
                console.log('updateCandidate!');
                _context7.next = 4;
                return _RegisterInstance["default"].getAccessToken('candidate:write');

              case 4:
                token = _context7.sent;
                _context7.next = 7;
                return (0, _HttpRequest.httpPutJsonEncoded)("".concat(_BuildConstants.RECRUIT_HOST, "/").concat(CANDIDATE_URL_AUTH, "/").concat(candidateData.id), candidateData, null, STRUCTURE_TIMEOUT, 10, 'Bearer ' + token);

              case 7:
                response = _context7.sent;
                console.log('response', response);

                if (!(response.status !== 200)) {
                  _context7.next = 11;
                  break;
                }

                return _context7.abrupt("return", _promise["default"].reject(response.data.errors[0]));

              case 11:
                return _context7.abrupt("return", _promise["default"].resolve(response.data));

              case 14:
                _context7.prev = 14;
                _context7.t0 = _context7["catch"](0);
                console.log('ERROR: could not update candidate', _context7.t0);
                return _context7.abrupt("return", _promise["default"].reject(_context7.t0));

              case 18:
              case "end":
                return _context7.stop();
            }
          }
        }, _callee7, null, [[0, 14]]);
      }));

      function updateCandidate(_x4) {
        return _updateCandidate.apply(this, arguments);
      }

      return updateCandidate;
    }()
  }, {
    key: "createRequestCode",
    value: function () {
      var _createRequestCode = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee8() {
        var token, response;
        return _regenerator["default"].wrap(function _callee8$(_context8) {
          while (1) {
            switch (_context8.prev = _context8.next) {
              case 0:
                _context8.prev = 0;
                console.log('createRequestCode!');
                _context8.next = 4;
                return _RegisterInstance["default"].getAccessToken('authUser:createRequestCode');

              case 4:
                token = _context8.sent;
                _context8.next = 7;
                return (0, _HttpRequest.httpPostJsonEncoded)("".concat(_BuildConstants.AUTH_HOST, "/").concat(RECRUITER_CONFIG_URL_AUTH), {}, null, STRUCTURE_TIMEOUT, 10, 'Bearer ' + token);

              case 7:
                response = _context8.sent;
                console.log('response createRequestCode', response);

                if (!(response.status !== 200)) {
                  _context8.next = 11;
                  break;
                }

                return _context8.abrupt("return", _promise["default"].reject(response.data.errors[0]));

              case 11:
                return _context8.abrupt("return", _promise["default"].resolve(response.data));

              case 14:
                _context8.prev = 14;
                _context8.t0 = _context8["catch"](0);
                console.log('ERROR: createRequestCode', _context8.t0);
                return _context8.abrupt("return", _promise["default"].reject(_context8.t0));

              case 18:
              case "end":
                return _context8.stop();
            }
          }
        }, _callee8, null, [[0, 14]]);
      }));

      function createRequestCode() {
        return _createRequestCode.apply(this, arguments);
      }

      return createRequestCode;
    }()
  }, {
    key: "getGlobalRanking",
    value: function () {
      var _getGlobalRanking = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee9() {
        var data, token, response;
        return _regenerator["default"].wrap(function _callee9$(_context9) {
          while (1) {
            switch (_context9.prev = _context9.next) {
              case 0:
                _context9.prev = 0;
                console.log('getGlobalRanking!');
                _context9.next = 4;
                return _RegisterInstance["default"].getApplicationInstanceId();

              case 4:
                _context9.t0 = _context9.sent;
                data = {
                  deviceuuid: _context9.t0
                };
                _context9.next = 8;
                return _RegisterInstance["default"].getAccessToken('structure:read');

              case 8:
                token = _context9.sent;
                _context9.next = 11;
                return (0, _HttpRequest.httpGet)("".concat(_BuildConstants.AUTH_HOST, "/").concat(GET_GLOBAL_RANKING_URL_AUTH), data, null, STRUCTURE_TIMEOUT, 10, 'Bearer ' + token);

              case 11:
                response = _context9.sent;

                if (!(response.data.success !== true)) {
                  _context9.next = 14;
                  break;
                }

                return _context9.abrupt("return", _promise["default"].reject(response.data.errors[0]));

              case 14:
                return _context9.abrupt("return", _promise["default"].resolve(response.data));

              case 17:
                _context9.prev = 17;
                _context9.t1 = _context9["catch"](0);
                console.log('ERROR: could not get global ranking', _context9.t1);
                return _context9.abrupt("return", _promise["default"].reject(_context9.t1));

              case 21:
              case "end":
                return _context9.stop();
            }
          }
        }, _callee9, null, [[0, 17]]);
      }));

      function getGlobalRanking() {
        return _getGlobalRanking.apply(this, arguments);
      }

      return getGlobalRanking;
    }()
  }, {
    key: "getUserPictures",
    value: function () {
      var _getUserPictures = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee10(userNames) {
        var data, token, response;
        return _regenerator["default"].wrap(function _callee10$(_context10) {
          while (1) {
            switch (_context10.prev = _context10.next) {
              case 0:
                _context10.prev = 0;
                console.log('getUserPictures!');
                _context10.next = 4;
                return _RegisterInstance["default"].getApplicationInstanceId();

              case 4:
                _context10.t0 = _context10.sent;
                _context10.t1 = userNames;
                data = {
                  deviceuuid: _context10.t0,
                  usernames: _context10.t1
                };
                _context10.next = 9;
                return _RegisterInstance["default"].getAccessToken('structure:read');

              case 9:
                token = _context10.sent;
                _context10.next = 12;
                return (0, _HttpRequest.httpPostJsonEncoded)("".concat(_BuildConstants.AUTH_HOST, "/").concat(GET_USER_PICTURES_URL_AUTH), data, null, STRUCTURE_TIMEOUT, 10, 'Bearer ' + token);

              case 12:
                response = _context10.sent;
                console.log('getUserPictures', response);

                if (!(response.data.success !== true)) {
                  _context10.next = 16;
                  break;
                }

                return _context10.abrupt("return", _promise["default"].reject(response.error));

              case 16:
                return _context10.abrupt("return", _promise["default"].resolve(response.data.users));

              case 19:
                _context10.prev = 19;
                _context10.t2 = _context10["catch"](0);
                console.log('ERROR: could not get user pictures', _context10.t2);
                return _context10.abrupt("return", _promise["default"].reject(_context10.t2));

              case 23:
              case "end":
                return _context10.stop();
            }
          }
        }, _callee10, null, [[0, 19]]);
      }));

      function getUserPictures(_x5) {
        return _getUserPictures.apply(this, arguments);
      }

      return getUserPictures;
    }()
  }, {
    key: "getActivityData",
    value: function () {
      var _getActivityData = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee11() {
        var data, token, response;
        return _regenerator["default"].wrap(function _callee11$(_context11) {
          while (1) {
            switch (_context11.prev = _context11.next) {
              case 0:
                _context11.prev = 0;
                console.log('getActivityData!');
                _context11.next = 4;
                return _RegisterInstance["default"].getApplicationInstanceId();

              case 4:
                _context11.t0 = _context11.sent;
                data = {
                  deviceuuid: _context11.t0
                };
                _context11.next = 8;
                return _RegisterInstance["default"].getAccessToken('structure:read');

              case 8:
                token = _context11.sent;
                _context11.next = 11;
                return (0, _HttpRequest.httpGet)("".concat(_BuildConstants.AUTH_HOST, "/").concat(GET_ACTIVITY_URL_AUTH), data, null, STRUCTURE_TIMEOUT, 10, 'Bearer ' + token);

              case 11:
                response = _context11.sent;

                if (!(response.data.success !== true)) {
                  _context11.next = 14;
                  break;
                }

                return _context11.abrupt("return", _promise["default"].reject(response.data.errors[0]));

              case 14:
                return _context11.abrupt("return", _promise["default"].resolve(response.data));

              case 17:
                _context11.prev = 17;
                _context11.t1 = _context11["catch"](0);
                console.log('ERROR: could not get activity data', _context11.t1);
                return _context11.abrupt("return", _promise["default"].reject(_context11.t1));

              case 21:
              case "end":
                return _context11.stop();
            }
          }
        }, _callee11, null, [[0, 17]]);
      }));

      function getActivityData() {
        return _getActivityData.apply(this, arguments);
      }

      return getActivityData;
    }()
  }, {
    key: "createActivationCode",
    value: function () {
      var _createActivationCode = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee12() {
        var data, token, response;
        return _regenerator["default"].wrap(function _callee12$(_context12) {
          while (1) {
            switch (_context12.prev = _context12.next) {
              case 0:
                _context12.prev = 0;
                console.log('createActivationCode!');
                _context12.next = 4;
                return _RegisterInstance["default"].getApplicationInstanceId();

              case 4:
                _context12.t0 = _context12.sent;
                data = {
                  deviceuuid: _context12.t0
                };
                _context12.next = 8;
                return _RegisterInstance["default"].getAccessToken('authUser:createRequestCode');

              case 8:
                token = _context12.sent;
                _context12.next = 11;
                return (0, _HttpRequest.httpPost)("".concat(_BuildConstants.AUTH_HOST, "/").concat(CREATE_ACTIVATON_CODE_URL_AUTH), data, null, false, USER_MANAGEMENT_HTTP_TIMEOUT, 10, 'Bearer ' + token);

              case 11:
                response = _context12.sent;

                if (!(response.data.success !== true)) {
                  _context12.next = 14;
                  break;
                }

                return _context12.abrupt("return", _promise["default"].reject(response.data.errors[0]));

              case 14:
                return _context12.abrupt("return", _promise["default"].resolve(response.data));

              case 17:
                _context12.prev = 17;
                _context12.t1 = _context12["catch"](0);
                console.log('ERROR: could not get user', _context12.t1);
                return _context12.abrupt("return", _promise["default"].reject(_context12.t1));

              case 21:
              case "end":
                return _context12.stop();
            }
          }
        }, _callee12, null, [[0, 17]]);
      }));

      function createActivationCode() {
        return _createActivationCode.apply(this, arguments);
      }

      return createActivationCode;
    }()
  }, {
    key: "sendPushToUuid",
    value: function () {
      var _sendPushToUuid = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee13(receiverUuid, message, title, code) {
        var data, token, response;
        return _regenerator["default"].wrap(function _callee13$(_context13) {
          while (1) {
            switch (_context13.prev = _context13.next) {
              case 0:
                _context13.prev = 0;
                console.log('sendPushToUuid!', receiverUuid, message, title, code);
                data = {
                  receiverList: {
                    filter: {
                      requestCode: code,
                      dataStore: [{
                        path: 'client.tracking.applicationInstanceId',
                        operation: '==',
                        value: receiverUuid
                      }]
                    }
                  },
                  message: {
                    title: title,
                    body: message,
                    ttl: 3600,
                    data: {}
                  }
                }; // const header = {
                //   'Content-Type': 'application/json'
                // }

                _context13.next = 5;
                return _RegisterInstance["default"].getAccessToken('push:send');

              case 5:
                token = _context13.sent;
                _context13.next = 8;
                return (0, _HttpRequest.httpPostJsonEncoded)("".concat(_BuildConstants.AUTH_HOST, "/").concat(SEND_PUSH_FILTERED_URL_AUTH), data, null, SEND_PUSH_TIMEOUT, 10, 'Bearer ' + token);

              case 8:
                response = _context13.sent;

                if (!(response.data.success !== true)) {
                  _context13.next = 11;
                  break;
                }

                return _context13.abrupt("return", _promise["default"].reject(response.data.errors[0]));

              case 11:
                return _context13.abrupt("return", _promise["default"].resolve(response.data));

              case 14:
                _context13.prev = 14;
                _context13.t0 = _context13["catch"](0);
                console.log('ERROR: could not get user', _context13.t0);
                return _context13.abrupt("return", _promise["default"].reject(_context13.t0));

              case 18:
              case "end":
                return _context13.stop();
            }
          }
        }, _callee13, null, [[0, 14]]);
      }));

      function sendPushToUuid(_x6, _x7, _x8, _x9) {
        return _sendPushToUuid.apply(this, arguments);
      }

      return sendPushToUuid;
    }()
  }, {
    key: "sendPush",
    value: function () {
      var _sendPush = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee14(receivers, message, title) {
        var data, token, response;
        return _regenerator["default"].wrap(function _callee14$(_context14) {
          while (1) {
            switch (_context14.prev = _context14.next) {
              case 0:
                _context14.prev = 0;
                console.log('sendPush!', receivers, message, title);
                _context14.next = 4;
                return _RegisterInstance["default"].getApplicationInstanceId();

              case 4:
                _context14.t0 = _context14.sent;
                _context14.t1 = receivers;
                _context14.t2 = {
                  title: title,
                  message: message,
                  sender: 'test'
                };
                data = {
                  deviceuuid: _context14.t0,
                  receivers: _context14.t1,
                  message: _context14.t2
                };
                _context14.next = 10;
                return _RegisterInstance["default"].getAccessToken('push:send');

              case 10:
                token = _context14.sent;
                _context14.next = 13;
                return (0, _HttpRequest.httpPostJsonEncoded)("".concat(_BuildConstants.AUTH_HOST, "/").concat(SEND_PUSH_URL_AUTH), data, null, SEND_PUSH_TIMEOUT, 10, 'Bearer ' + token);

              case 13:
                response = _context14.sent;

                if (!(response.data.success !== true)) {
                  _context14.next = 16;
                  break;
                }

                return _context14.abrupt("return", _promise["default"].reject(response.data.errors[0]));

              case 16:
                return _context14.abrupt("return", _promise["default"].resolve(response.data));

              case 19:
                _context14.prev = 19;
                _context14.t3 = _context14["catch"](0);
                console.log('ERROR: could not get user', _context14.t3);
                return _context14.abrupt("return", _promise["default"].reject(_context14.t3));

              case 23:
              case "end":
                return _context14.stop();
            }
          }
        }, _callee14, null, [[0, 19]]);
      }));

      function sendPush(_x10, _x11, _x12) {
        return _sendPush.apply(this, arguments);
      }

      return sendPush;
    }()
  }, {
    key: "checkSnomId",
    value: function () {
      var _checkSnomId = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee15(code) {
        var data, token, response;
        return _regenerator["default"].wrap(function _callee15$(_context15) {
          while (1) {
            switch (_context15.prev = _context15.next) {
              case 0:
                _context15.prev = 0;
                data = {
                  id: code
                };
                _context15.next = 4;
                return _RegisterInstance["default"].getAccessToken('authUser:register');

              case 4:
                token = _context15.sent;
                _context15.next = 7;
                return (0, _HttpRequest.httpPost)("".concat(_BuildConstants.AUTH_HOST, "/").concat(CHECK_SNOMID_URL_AUTH), data, null, false, USER_MANAGEMENT_HTTP_TIMEOUT, 10, 'Bearer ' + token);

              case 7:
                response = _context15.sent;

                if (!(response.data.success !== true)) {
                  _context15.next = 10;
                  break;
                }

                return _context15.abrupt("return", _promise["default"].reject(new Error(response.data.errors[0])));

              case 10:
                return _context15.abrupt("return", _promise["default"].resolve(response.data));

              case 13:
                _context15.prev = 13;
                _context15.t0 = _context15["catch"](0);
                return _context15.abrupt("return", _promise["default"].reject(_context15.t0));

              case 16:
              case "end":
                return _context15.stop();
            }
          }
        }, _callee15, null, [[0, 13]]);
      }));

      function checkSnomId(_x13) {
        return _checkSnomId.apply(this, arguments);
      }

      return checkSnomId;
    }()
  }, {
    key: "checkActivationCode",
    value: function () {
      var _checkActivationCode = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee16(code, nickname) {
        var useAuthServer,
            data,
            response,
            token,
            _args16 = arguments;
        return _regenerator["default"].wrap(function _callee16$(_context16) {
          while (1) {
            switch (_context16.prev = _context16.next) {
              case 0:
                useAuthServer = _args16.length > 2 && _args16[2] !== undefined ? _args16[2] : false;
                _context16.prev = 1;
                data = {
                  code: code
                };

                if (nickname) {
                  data.nickname = nickname;
                }

                if (!useAuthServer) {
                  _context16.next = 13;
                  break;
                }

                _context16.next = 7;
                return _RegisterInstance["default"].getAccessToken('authUser:register');

              case 7:
                token = _context16.sent;
                _context16.next = 10;
                return (0, _HttpRequest.httpPost)("".concat(_BuildConstants.AUTH_HOST, "/").concat(CHECK_ACTIVATION_URL_AUTH), data, null, false, USER_MANAGEMENT_HTTP_TIMEOUT, 10, 'Bearer ' + token);

              case 10:
                response = _context16.sent;
                _context16.next = 16;
                break;

              case 13:
                _context16.next = 15;
                return (0, _HttpRequest.httpPost)("".concat(_BuildConstants.HOST, "/").concat(CHECK_ACTIVATION_URL), data, null, false, USER_MANAGEMENT_HTTP_TIMEOUT, 10);

              case 15:
                response = _context16.sent;

              case 16:
                if (!(response.data.success !== true)) {
                  _context16.next = 18;
                  break;
                }

                return _context16.abrupt("return", _promise["default"].reject(new Error(response.data.errors[0])));

              case 18:
                return _context16.abrupt("return", _promise["default"].resolve(response.data));

              case 21:
                _context16.prev = 21;
                _context16.t0 = _context16["catch"](1);
                return _context16.abrupt("return", _promise["default"].reject(_context16.t0));

              case 24:
              case "end":
                return _context16.stop();
            }
          }
        }, _callee16, null, [[1, 21]]);
      }));

      function checkActivationCode(_x14, _x15) {
        return _checkActivationCode.apply(this, arguments);
      }

      return checkActivationCode;
    }()
  }, {
    key: "isActivated",
    value: function isActivated(featureName) {
      return _EquizzerActions["default"].isActivatedFeature(featureName);
    }
  }, {
    key: "revalidateUser",
    value: function () {
      var _revalidateUser = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee17(code, username, password, nickname) {
        var useAuthServer,
            data,
            response,
            token,
            nickNameForQD,
            subject,
            _args17 = arguments;
        return _regenerator["default"].wrap(function _callee17$(_context17) {
          while (1) {
            switch (_context17.prev = _context17.next) {
              case 0:
                useAuthServer = _args17.length > 4 && _args17[4] !== undefined ? _args17[4] : false;
                _context17.prev = 1;
                data = {
                  code: code,
                  username: username,
                  nickname: nickname,
                  password: password ? (0, _sha["default"])(password) : null
                };

                if (!useAuthServer) {
                  _context17.next = 12;
                  break;
                }

                _context17.next = 6;
                return _RegisterInstance["default"].getAccessToken('authUser:register');

              case 6:
                token = _context17.sent;
                _context17.next = 9;
                return (0, _HttpRequest.httpPost)("".concat(_BuildConstants.AUTH_HOST, "/").concat(REVALIDATE_USER_URL_AUTH), data, null, false, USER_MANAGEMENT_HTTP_TIMEOUT, 10, 'Bearer ' + token);

              case 9:
                response = _context17.sent;
                _context17.next = 15;
                break;

              case 12:
                _context17.next = 14;
                return (0, _HttpRequest.httpPost)("".concat(_BuildConstants.HOST, "/").concat(REVALIDATE_USER_URL), data, null, false, USER_MANAGEMENT_HTTP_TIMEOUT, 10);

              case 14:
                response = _context17.sent;

              case 15:
                if (!(response.data && response.data.user && response.data.user.additionalData)) {
                  _context17.next = 26;
                  break;
                }

                nickNameForQD = response.data.user.additionalData.nickName;
                _context17.next = 19;
                return _DataStore["default"].setSingleData(_DataStore.DATA_STORE_PATHS.BASE_QD_NICKNAME);

              case 19:
                if (response.data.user.additionalData.subjects && response.data.user.additionalData.subjects.length > 0) {
                  subject = response.data.user.additionalData.subjects[0];
                }

                if (!(_config["default"].useDrupalContent && nickNameForQD && subject)) {
                  _context17.next = 26;
                  break;
                }

                // +++*** Add timeout here!
                console.log('+++registerUserForQDInKesi, timeout!');
                _context17.next = 24;
                return new _promise["default"](function (resolve) {
                  return setTimeout(resolve, 1000);
                });

              case 24:
                _context17.next = 26;
                return (0, _EquizzerRegisterHelper.registerUserForQDInKesi)(nickNameForQD);

              case 26:
                if (!(response.data.success !== true)) {
                  _context17.next = 28;
                  break;
                }

                return _context17.abrupt("return", _promise["default"].reject(new Error(response.data.errors[0])));

              case 28:
                return _context17.abrupt("return", _promise["default"].resolve(response.data));

              case 31:
                _context17.prev = 31;
                _context17.t0 = _context17["catch"](1);
                return _context17.abrupt("return", _promise["default"].reject(_context17.t0));

              case 34:
              case "end":
                return _context17.stop();
            }
          }
        }, _callee17, null, [[1, 31]]);
      }));

      function revalidateUser(_x16, _x17, _x18, _x19) {
        return _revalidateUser.apply(this, arguments);
      }

      return revalidateUser;
    }()
  }, {
    key: "registerUser",
    value: function () {
      var _registerUser = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee18(code, nickname, password) {
        var useAuthServer,
            email,
            registrationToken,
            firstName,
            lastName,
            mailVerificationToken,
            data,
            response,
            token,
            nickNameForQD,
            subject,
            _args18 = arguments;
        return _regenerator["default"].wrap(function _callee18$(_context18) {
          while (1) {
            switch (_context18.prev = _context18.next) {
              case 0:
                useAuthServer = _args18.length > 3 && _args18[3] !== undefined ? _args18[3] : false;
                email = _args18.length > 4 && _args18[4] !== undefined ? _args18[4] : null;
                registrationToken = _args18.length > 5 && _args18[5] !== undefined ? _args18[5] : null;
                firstName = _args18.length > 6 && _args18[6] !== undefined ? _args18[6] : null;
                lastName = _args18.length > 7 && _args18[7] !== undefined ? _args18[7] : null;
                mailVerificationToken = _args18.length > 8 && _args18[8] !== undefined ? _args18[8] : null;
                _context18.prev = 6;
                data = {
                  nickname: nickname,
                  password: (0, _sha["default"])(password),
                  agreed: 'true',
                  firstname: firstName,
                  lastname: lastName,
                  token: mailVerificationToken
                };

                if (email) {
                  data.email = email;
                }

                if (code) {
                  data.code = code;
                }

                if (registrationToken) {
                  data.token = registrationToken;
                }

                console.log('register user', data);

                if (!useAuthServer) {
                  _context18.next = 21;
                  break;
                }

                _context18.next = 15;
                return _RegisterInstance["default"].getAccessToken('authUser:register');

              case 15:
                token = _context18.sent;
                _context18.next = 18;
                return (0, _HttpRequest.httpPost)("".concat(_BuildConstants.AUTH_HOST, "/").concat(CREATE_USER_URL_AUTH), data, null, false, USER_MANAGEMENT_HTTP_TIMEOUT, 10, 'Bearer ' + token);

              case 18:
                response = _context18.sent;
                _context18.next = 24;
                break;

              case 21:
                _context18.next = 23;
                return (0, _HttpRequest.httpPost)("".concat(_BuildConstants.HOST, "/").concat(CREATE_USER_URL), data, null, false, USER_MANAGEMENT_HTTP_TIMEOUT, 10);

              case 23:
                response = _context18.sent;

              case 24:
                console.log('registerUser', response);

                if (!(response.data && response.data.user && response.data.user.additionalData)) {
                  _context18.next = 33;
                  break;
                }

                nickNameForQD = response.data.user.additionalData.nickName;
                _context18.next = 29;
                return _DataStore["default"].setSingleData(_DataStore.DATA_STORE_PATHS.BASE_QD_NICKNAME);

              case 29:
                if (response.data.user.additionalData.subjects && response.data.user.additionalData.subjects.length > 0) {
                  subject = response.data.user.additionalData.subjects[0];
                }

                if (!(_config["default"].useDrupalContent && nickNameForQD && subject)) {
                  _context18.next = 33;
                  break;
                }

                _context18.next = 33;
                return (0, _EquizzerRegisterHelper.registerUserForQDInKesi)(nickNameForQD);

              case 33:
                if (!(response.data.success !== true)) {
                  _context18.next = 35;
                  break;
                }

                return _context18.abrupt("return", _promise["default"].reject(new Error(response.data.errors[0])));

              case 35:
                return _context18.abrupt("return", _promise["default"].resolve(response.data));

              case 38:
                _context18.prev = 38;
                _context18.t0 = _context18["catch"](6);
                return _context18.abrupt("return", _promise["default"].reject(_context18.t0));

              case 41:
              case "end":
                return _context18.stop();
            }
          }
        }, _callee18, null, [[6, 38]]);
      }));

      function registerUser(_x20, _x21, _x22) {
        return _registerUser.apply(this, arguments);
      }

      return registerUser;
    }()
  }, {
    key: "requestRegistrationToken",
    value: function () {
      var _requestRegistrationToken = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee19(code) {
        var email,
            data,
            token,
            response,
            _args19 = arguments;
        return _regenerator["default"].wrap(function _callee19$(_context19) {
          while (1) {
            switch (_context19.prev = _context19.next) {
              case 0:
                email = _args19.length > 1 && _args19[1] !== undefined ? _args19[1] : null;
                _context19.prev = 1;
                data = {
                  email: email,
                  code: code
                };
                _context19.next = 5;
                return _RegisterInstance["default"].getAccessToken('authUser:register');

              case 5:
                token = _context19.sent;
                _context19.next = 8;
                return (0, _HttpRequest.httpPost)("".concat(_BuildConstants.AUTH_HOST, "/").concat(REQUEST_REGISTRATION_TOKEN_URL_AUTH), data, null, false, USER_MANAGEMENT_HTTP_TIMEOUT, 10, 'Bearer ' + token);

              case 8:
                response = _context19.sent;

                if (!(response.data.success !== true)) {
                  _context19.next = 11;
                  break;
                }

                return _context19.abrupt("return", _promise["default"].reject(new Error(response.data.errors[0])));

              case 11:
                return _context19.abrupt("return", _promise["default"].resolve(response.data));

              case 14:
                _context19.prev = 14;
                _context19.t0 = _context19["catch"](1);
                return _context19.abrupt("return", _promise["default"].reject(_context19.t0));

              case 17:
              case "end":
                return _context19.stop();
            }
          }
        }, _callee19, null, [[1, 14]]);
      }));

      function requestRegistrationToken(_x23) {
        return _requestRegistrationToken.apply(this, arguments);
      }

      return requestRegistrationToken;
    }()
  }, {
    key: "checkRegistrationToken",
    value: function () {
      var _checkRegistrationToken = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee20(code, registrationToken) {
        var email,
            data,
            token,
            response,
            _args20 = arguments;
        return _regenerator["default"].wrap(function _callee20$(_context20) {
          while (1) {
            switch (_context20.prev = _context20.next) {
              case 0:
                email = _args20.length > 2 && _args20[2] !== undefined ? _args20[2] : null;
                _context20.prev = 1;
                data = {
                  email: email,
                  code: code,
                  token: registrationToken
                };
                _context20.next = 5;
                return _RegisterInstance["default"].getAccessToken('authUser:register');

              case 5:
                token = _context20.sent;
                _context20.next = 8;
                return (0, _HttpRequest.httpPost)("".concat(_BuildConstants.AUTH_HOST, "/").concat(CHECK_REGISTRATION_TOKEN_URL_AUTH), data, null, false, USER_MANAGEMENT_HTTP_TIMEOUT, 10, 'Bearer ' + token);

              case 8:
                response = _context20.sent;
                console.log('checkRegistrationToken', response);

                if (!(response.data.success !== true)) {
                  _context20.next = 12;
                  break;
                }

                return _context20.abrupt("return", _promise["default"].reject(new Error(response.data.errors[0])));

              case 12:
                return _context20.abrupt("return", _promise["default"].resolve(response.data));

              case 15:
                _context20.prev = 15;
                _context20.t0 = _context20["catch"](1);
                console.log('checkRegistrationToken error', _context20.t0);
                return _context20.abrupt("return", _promise["default"].reject(_context20.t0));

              case 19:
              case "end":
                return _context20.stop();
            }
          }
        }, _callee20, null, [[1, 15]]);
      }));

      function checkRegistrationToken(_x24, _x25) {
        return _checkRegistrationToken.apply(this, arguments);
      }

      return checkRegistrationToken;
    }()
  }, {
    key: "checkPasswordResetToken",
    value: function () {
      var _checkPasswordResetToken = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee21(code, registrationToken) {
        var data, token, response;
        return _regenerator["default"].wrap(function _callee21$(_context21) {
          while (1) {
            switch (_context21.prev = _context21.next) {
              case 0:
                _context21.prev = 0;
                data = {
                  code: code,
                  token: registrationToken
                };
                _context21.next = 4;
                return _RegisterInstance["default"].getAccessToken('authUser:register');

              case 4:
                token = _context21.sent;
                _context21.next = 7;
                return (0, _HttpRequest.httpPost)("".concat(_BuildConstants.AUTH_HOST, "/").concat(CHECK_PASSWORD_RESET_TOKEN_URL_AUTH), data, null, false, USER_MANAGEMENT_HTTP_TIMEOUT, 10, 'Bearer ' + token);

              case 7:
                response = _context21.sent;

                if (!(response.data.success !== true)) {
                  _context21.next = 10;
                  break;
                }

                return _context21.abrupt("return", _promise["default"].reject(new Error(response.data.errors[0])));

              case 10:
                return _context21.abrupt("return", _promise["default"].resolve(response.data));

              case 13:
                _context21.prev = 13;
                _context21.t0 = _context21["catch"](0);
                return _context21.abrupt("return", _promise["default"].reject(_context21.t0));

              case 16:
              case "end":
                return _context21.stop();
            }
          }
        }, _callee21, null, [[0, 13]]);
      }));

      function checkPasswordResetToken(_x26, _x27) {
        return _checkPasswordResetToken.apply(this, arguments);
      }

      return checkPasswordResetToken;
    }()
  }, {
    key: "requestPasswordReset",
    value: function () {
      var _requestPasswordReset = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee22(username, code, nickname) {
        var useAuthServer,
            data,
            response,
            token,
            _args22 = arguments;
        return _regenerator["default"].wrap(function _callee22$(_context22) {
          while (1) {
            switch (_context22.prev = _context22.next) {
              case 0:
                useAuthServer = _args22.length > 3 && _args22[3] !== undefined ? _args22[3] : false;
                _context22.prev = 1;
                data = {
                  username: username,
                  code: code,
                  nickname: nickname
                };

                if (!useAuthServer) {
                  _context22.next = 12;
                  break;
                }

                _context22.next = 6;
                return _RegisterInstance["default"].getAccessToken('authUser:register');

              case 6:
                token = _context22.sent;
                _context22.next = 9;
                return (0, _HttpRequest.httpPost)("".concat(_BuildConstants.AUTH_HOST, "/").concat(REQUEST_PASSWORD_RESET_URL_AUTH), data, null, false, USER_MANAGEMENT_HTTP_TIMEOUT, 10, 'Bearer ' + token);

              case 9:
                response = _context22.sent;
                _context22.next = 15;
                break;

              case 12:
                _context22.next = 14;
                return (0, _HttpRequest.httpPost)("".concat(_BuildConstants.HOST, "/").concat(REQUEST_PASSWORD_RESET_URL), data, null, false, USER_MANAGEMENT_HTTP_TIMEOUT, 10);

              case 14:
                response = _context22.sent;

              case 15:
                if (!(response.data.success !== true)) {
                  _context22.next = 17;
                  break;
                }

                return _context22.abrupt("return", _promise["default"].reject(new Error(response.data.errors[0])));

              case 17:
                return _context22.abrupt("return", _promise["default"].resolve(response.data));

              case 20:
                _context22.prev = 20;
                _context22.t0 = _context22["catch"](1);
                return _context22.abrupt("return", _promise["default"].reject(_context22.t0));

              case 23:
              case "end":
                return _context22.stop();
            }
          }
        }, _callee22, null, [[1, 20]]);
      }));

      function requestPasswordReset(_x28, _x29, _x30) {
        return _requestPasswordReset.apply(this, arguments);
      }

      return requestPasswordReset;
    }()
  }, {
    key: "requestUsernameSend",
    value: function () {
      var _requestUsernameSend = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee23(code, username, email) {
        var useAuthServer,
            data,
            response,
            token,
            _args23 = arguments;
        return _regenerator["default"].wrap(function _callee23$(_context23) {
          while (1) {
            switch (_context23.prev = _context23.next) {
              case 0:
                useAuthServer = _args23.length > 3 && _args23[3] !== undefined ? _args23[3] : false;
                _context23.prev = 1;
                data = {
                  code: code,
                  username: username,
                  email: email
                };

                if (!useAuthServer) {
                  _context23.next = 12;
                  break;
                }

                _context23.next = 6;
                return _RegisterInstance["default"].getAccessToken('authUser:register');

              case 6:
                token = _context23.sent;
                _context23.next = 9;
                return (0, _HttpRequest.httpPost)("".concat(_BuildConstants.AUTH_HOST, "/").concat(REQUEST_USERNAME_SEND_AUTH), data, null, false, USER_MANAGEMENT_HTTP_TIMEOUT, 10, 'Bearer ' + token);

              case 9:
                response = _context23.sent;
                _context23.next = 15;
                break;

              case 12:
                _context23.next = 14;
                return (0, _HttpRequest.httpPost)("".concat(_BuildConstants.HOST, "/").concat(REQUEST_USERNAME_SEND), data, null, false, USER_MANAGEMENT_HTTP_TIMEOUT, 10);

              case 14:
                response = _context23.sent;

              case 15:
                if (!(response.data.success !== true)) {
                  _context23.next = 17;
                  break;
                }

                return _context23.abrupt("return", _promise["default"].reject(new Error(response.data.errors[0])));

              case 17:
                return _context23.abrupt("return", _promise["default"].resolve(response.data));

              case 20:
                _context23.prev = 20;
                _context23.t0 = _context23["catch"](1);
                return _context23.abrupt("return", _promise["default"].reject(_context23.t0));

              case 23:
              case "end":
                return _context23.stop();
            }
          }
        }, _callee23, null, [[1, 20]]);
      }));

      function requestUsernameSend(_x31, _x32, _x33) {
        return _requestUsernameSend.apply(this, arguments);
      }

      return requestUsernameSend;
    }()
  }, {
    key: "changePassword",
    value: function () {
      var _changePassword = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee24(username, password) {
        var nickname,
            useAuthServer,
            data,
            response,
            token,
            _args24 = arguments;
        return _regenerator["default"].wrap(function _callee24$(_context24) {
          while (1) {
            switch (_context24.prev = _context24.next) {
              case 0:
                nickname = _args24.length > 2 && _args24[2] !== undefined ? _args24[2] : null;
                useAuthServer = _args24.length > 3 && _args24[3] !== undefined ? _args24[3] : false;
                _context24.prev = 2;
                data = {
                  username: username,
                  nickname: nickname,
                  newpassword: (0, _sha["default"])(password)
                };

                if (!useAuthServer) {
                  _context24.next = 13;
                  break;
                }

                _context24.next = 7;
                return _RegisterInstance["default"].getAccessToken('authUser:register');

              case 7:
                token = _context24.sent;
                _context24.next = 10;
                return (0, _HttpRequest.httpPost)("".concat(_BuildConstants.AUTH_HOST, "/").concat(CHANGE_PASSWORD_URL_AUTH), data, null, false, USER_MANAGEMENT_HTTP_TIMEOUT, 10, 'Bearer ' + token);

              case 10:
                response = _context24.sent;
                _context24.next = 16;
                break;

              case 13:
                _context24.next = 15;
                return (0, _HttpRequest.httpPost)("".concat(_BuildConstants.HOST, "/").concat(CHANGE_PASSWORD_URL), data, null, false, USER_MANAGEMENT_HTTP_TIMEOUT, 10);

              case 15:
                response = _context24.sent;

              case 16:
                if (!(response.data.success !== true)) {
                  _context24.next = 18;
                  break;
                }

                return _context24.abrupt("return", _promise["default"].reject(new Error(response.data.errors[0])));

              case 18:
                return _context24.abrupt("return", _promise["default"].resolve(response.data));

              case 21:
                _context24.prev = 21;
                _context24.t0 = _context24["catch"](2);
                return _context24.abrupt("return", _promise["default"].reject(_context24.t0));

              case 24:
              case "end":
                return _context24.stop();
            }
          }
        }, _callee24, null, [[2, 21]]);
      }));

      function changePassword(_x34, _x35) {
        return _changePassword.apply(this, arguments);
      }

      return changePassword;
    }()
  }, {
    key: "checkListStates",
    value: function () {
      var _checkListStates = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee25() {
        var useAuthServer,
            response,
            token,
            _args25 = arguments;
        return _regenerator["default"].wrap(function _callee25$(_context25) {
          while (1) {
            switch (_context25.prev = _context25.next) {
              case 0:
                useAuthServer = _args25.length > 0 && _args25[0] !== undefined ? _args25[0] : false;
                _context25.prev = 1;

                if (!useAuthServer) {
                  _context25.next = 11;
                  break;
                }

                _context25.next = 5;
                return _RegisterInstance["default"].getAccessToken('authUser:register');

              case 5:
                token = _context25.sent;
                _context25.next = 8;
                return (0, _HttpRequest.httpGet)("".concat(_BuildConstants.AUTH_HOST, "/").concat(CHECK_LIST_STATES_URL_AUTH), null, null, USER_MANAGEMENT_HTTP_TIMEOUT, 10, 'Bearer ' + token);

              case 8:
                response = _context25.sent;
                _context25.next = 14;
                break;

              case 11:
                _context25.next = 13;
                return (0, _HttpRequest.httpGet)("".concat(_BuildConstants.HOST, "/").concat(CHECK_LIST_STATES_URL), null, null, USER_MANAGEMENT_HTTP_TIMEOUT, 10);

              case 13:
                response = _context25.sent;

              case 14:
                if (!(response.data.success !== true)) {
                  _context25.next = 16;
                  break;
                }

                return _context25.abrupt("return", _promise["default"].reject(new Error(response.data.errors[0])));

              case 16:
                return _context25.abrupt("return", _promise["default"].resolve(response.data));

              case 19:
                _context25.prev = 19;
                _context25.t0 = _context25["catch"](1);
                return _context25.abrupt("return", _promise["default"].reject(_context25.t0));

              case 22:
              case "end":
                return _context25.stop();
            }
          }
        }, _callee25, null, [[1, 19]]);
      }));

      function checkListStates() {
        return _checkListStates.apply(this, arguments);
      }

      return checkListStates;
    }()
  }]);
  return UserManagementService;
}();

var _default = UserManagementService;
exports["default"] = _default;